const config = {
  apiBaseUrl: process.env.REACT_APP_API_URL || 'http://localhost:5006/api'
};

export default config; 